export default "__VITE_ASSET__Bc26o_Vf__"